import dayjs from 'dayjs';

export const DateService = dayjs;

